import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import SewerageWorkTypePopup from './SewerageWorkTypePopup'
import { SeverageWorkTypeDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkTypeDataDDL'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SeverageWorkTypeDeleteAPI, SeverageWorkTypeExportTableDataAPI, SeverageWorkTypeTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeverageWorkTypeMasterSlice'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../../Helper/Loading'
import { GardenMasterExportData } from '../../../../GardenData/GardenMasterExportData'
import { SewerageWorkTypeExportData } from './SewerageWorkTypeExportData'

export default function SewerageWorkTypeData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(ApiFlag)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [LocationMasterPopupShow, setLocationMasterPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')


    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()

    const [SeverageWorkType, setSeverageWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // console.log(searchParams)

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSewerageMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setSeverageWorkType({
            ...SeverageWorkType,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleShowImage = (img) => {
        setLocationMasterPopupShow(true)
        setImagePopUpData(img)
    }


    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_WorkTypeID: SeverageWorkType.ID,
            WorkType: '',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleSeverageWorkTypeExport: handleSeverageWorkTypeExport
        }
        // if (SeverageWorkType.ID != "0") {
        dispatch(SeverageWorkTypeTableDataAPI({ data }))
        // }

    }, [IsPost, To, isSearch, IsClear,SeverageWorkType.ID])
    const { tableData, isLoading } = useSelector(state => state.SeverageWorkTypeTableData)


    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleSeverageWorkTypeExport = () => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_WorkTypeID: SeverageWorkType.ID,
            WorkType: '',
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        // if (SeverageWorkType.ID != "0") {
        dispatch(SeverageWorkTypeExportTableDataAPI({ data }))
        // }

    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.SeverageWorkTypeExportTableData)

    const handleDeleteApi = (item) => {

        const data = {
            M_SW_WorkTypeID: item.m_sW_WorkTypeID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(SeverageWorkTypeDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.SeverageWorkTypeDeleteData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [SeverageWorkType.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName}
                    setYearValue={setYearValue}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className='data_mob'>
                            <div className="row m-1 py-1 master_border">
                                <div>
                                    <div className='row'>
                                        <h5 className="mt-lg-1">Work Type Master</h5>
                                        <div className="float-end butt">
                                            {
                                                isExportLoading ?
                                                    <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                        <i
                                                            className="fa fa-refresh fa-spin"
                                                            style={{ marginRight: "5px" }}
                                                        />Loading</button>
                                                    :
                                                    tableData && tableData.table && tableData.table.length > 0 &&
                                                    <SewerageWorkTypeExportData
                                                        ExcelData={ExportTableData}
                                                        name='Work Type Master'
                                                        searchName={searchName}
                                                    />
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-1 mb-2 m-0">
                                        <div className="col-12 rounded rounded-2 shadow"
                                            style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                            <div className="col-12">

                                                <div className="row mt-1 rounded2">
                                                    <div className="col-12 col-lg-3 col-md-4">
                                                        <SeverageWorkTypeDataDDL
                                                            SeverageWorkType={SeverageWorkType}
                                                            setSeverageWorkType={setSeverageWorkType}
                                                            IsPost={IsPost}
                                                        />

                                                    </div>

                                                    <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary mx-2"
                                                            onClick={handleSearch}
                                                        >
                                                            Search</button>
                                                        <button type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={handleClear}
                                                        >
                                                            Clear</button>
                                                    </div>
                                                </div>
                                                <div className="row table-responsive mob_table mt-2">
                                                    <table id="totalordergenerated"
                                                        cellPadding="0"
                                                        cellSpacing="0"
                                                        border="0"
                                                        className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="sr_no_col">Sr No.</th>
                                                                <th>Work Type</th>
                                                                {/* {
                                                                    searchName != "Work Type" ? */}
                                                                <th className='action-col'>Action</th>
                                                                {/* : <></>
                                                                } */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                    <tr style={{ width: '100%' }}>
                                                                        <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                        <td>{item.workType ? item.workType : '-'}</td>
                                                                        {/* {
                                                                            searchName != "Work Type" ? */}

                                                                        <td style={{ textAlign: "center", width: '7%' }}>
                                                                            <span >
                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                >
                                                                                </i>
                                                                            </span>
                                                                            <span>
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                    item={item}
                                                                                />
                                                                            </span>
                                                                        </td>
                                                                        {/* : <></>
                                                                        } */}
                                                                    </tr>
                                                                )) :
                                                                    <td colSpan={15}>No data found</td>
                                                            }
                                                        </tbody>
                                                    </table>


                                                </div>

                                                {tableData && tableData.table && tableData.table.length > 0 &&
                                                    <Pegination
                                                        PerPageCount={PerPageCount}
                                                        TotalCount={tableData.table[0].totalCount}
                                                        setFrom={setFrom}
                                                        setTo={setTo}
                                                        setrowNo={setrowNo}
                                                        CurrentPage={CurrentPage}
                                                        setCurrentPage={setCurrentPage}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        SewerageMasterPopupShow ?
                            <SewerageWorkTypePopup
                                open={SewerageMasterPopupShow}
                                popupHeading="Work Type Data"
                                handleIsPost={handleIsPost}
                                handleOnCloseClick={handleOnCloseClick}
                                Flag={apiFlag}
                                rowData={rowData}
                            // IsPost={IsPost}
                            />
                            : <></>
                    }
                </div >
            </div >
        </>
    )
}